<template>
    <div class="container">
        <!--<form>-->
            <!--<div class="row">-->
                <!--<div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">-->
                    <!--<h1>Stopwatch</h1>-->
                    <!--<div class="form-group">-->
                        <!--<label for="mode">-->
                            <!--<input type="radio" id="mode" v-model="mode" value="stopwatch"> Chronometre-->
                        <!--</label>-->
                        <!--<label for="mode">-->
                            <!--<input type="radio" id="mode" v-model="mode" value="timer"> Minuteur-->
                        <!--</label>-->
                    <!--</div>-->

                <!--</div>-->
            <!--</div>-->
        <!--</form>-->
        <div class="row">
            <div class="d-none d-sm-block col text-center"><h1>{{counter}} sec.</h1></div>
            <div class="d-block d-sm-none col text-center"><h3>{{counter}} sec.</h3></div>
            <span>
                <audio id="risingSound"
                        src="src/assets/sounds/uprising2.m4a"
                        type="audio/mp4"
                >
                    Your browser does not support the
                    <code>audio</code> element.
                </audio>
            </span>
        </div>
        <div class="row">
            <div class="col">
                <div class="progress">
                    <div class="progress-bar" role="progressBar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
                         :style="{width: (counter / maxTime * 100) + '%'}">
                    </div>
                </div>
            </div>
        </div>
        <hr class="d-none d-sm-block">
        <form class="form-group">
            <div v-if="mode == 'stopwatch'">
                <!--<div class="row">-->
                    <!--<div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">-->
                        <!--<h2>Chronomètre</h2>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="row">
                    <div class="col" v-if="(!isRunning && (status==0))">
                        <button class="d-none d-sm-block btn btn-square-sm btn-block btn-primary block-center" @click.prevent="start('stopwatch', maxTime, interval)">Commencer</button>
                        <button class="d-block d-sm-none btn btn-square-xs btn-block btn-primary block-center" @click.prevent="start('stopwatch', maxTime, interval)">Commencer</button>
                    </div>
                    <div class="col" v-if="(!isRunning && (status==1))">
                        <button class="d-none d-sm-block btn btn-rectangle-sm-a btn-block btn-success" @click.prevent="submitted('stopwatch', maxTime)">Valider</button>
                        <button class="d-none d-sm-block btn btn-rectangle-sm-b btn-block btn-outline-secondary" @click.prevent="start('stopwatch', maxTime, interval)">Recommencer</button>
                        <button class="d-block d-sm-none btn btn-rectangle-xs-a btn-block btn-success" @click.prevent="submitted('stopwatch', maxTime)">Valider</button>
                        <button class="d-block d-sm-none btn btn-rectangle-xs-b btn-block btn-outline-secondary" @click.prevent="start('stopwatch', maxTime, interval)">Recommencer</button>
                    </div>
                    <div class="col" v-if="isRunning">
                        <button class="d-none d-sm-block btn btn-square-sm btn-block btn-warning" @click.prevent="stop">Stop</button>
                        <button class="d-block d-sm-none btn btn-square-xs btn-block btn-warning" @click.prevent="stop">Stop</button>
                    </div>
                    <hr>
                </div>
            </div>
            <div v-if="mode == 'timer'">
                <!--<div class="row">-->
                    <!--<div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">-->
                        <!--<h2>Minuteur</h2>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="row">
                    <div class="col" v-if="(!isRunning && (status==0))">
                        <button class="d-none d-sm-block btn btn-square-sm btn-block btn-primary block-center" @click.prevent="start('timer', maxTime, interval)">Commencer</button>
                        <button class="d-block d-sm-none btn btn-square-xs btn-block btn-primary block-center" @click.prevent="start('timer', maxTime, interval)">Commencer</button>
                    </div>
                    <div class="col" v-if="(!isRunning && (status==1))">
                        <button class="d-none d-sm-block btn btn-rectangle-sm-a btn-block btn-success" @click.prevent="submitted('timer', maxTime)">Valider</button>
                        <button class="d-none d-sm-block btn btn-rectangle-sm-b btn-block btn-outline-secondary" @click.prevent="start('timer', maxTime, interval)">Recommencer</button>
                        <button class="d-block d-sm-none btn btn-rectangle-xs-a btn-block btn-success" @click.prevent="submitted('timer', maxTime)">Valider</button>
                        <button class="d-block d-sm-none btn btn-rectangle-xs-b btn-block btn-outline-secondary" @click.prevent="start('timer', maxTime, interval)">Recommencer</button>
                    </div>
                    <div class="col" v-if="isRunning">
                        <button class="d-none d-sm-block btn btn-square-sm btn-block btn-warning" @click.prevent="stop">Stop</button>
                        <button class="d-block d-sm-none btn btn-square-xs btn-block btn-warning" @click.prevent="stop">Stop</button>
                    </div>
                    <hr>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                run: false,
                counter: 0,
                isRunning: false,
                status: 0,
                mode: 'stopwatch',
            }
        },
        props: ['maxTime', 'interval', 'soundMode'],

        computed: {

        },
        methods: {
            playSound: function(soundMode){
                if(soundMode == true) {
                    let x = document.getElementById("risingSound");
                    x.play();
                }
            },
            count: function(mode, limit, soundMode){
                this.status = 1;
                if(mode == 'stopwatch') {
                    if (this.counter < limit) {
                        this.counter = this.counter + 1;
                    } else {
                        this.stop();
                        this.playSound(soundMode);
                    }
                } else {
                    //timer
                    if (this.counter > 0) {
                        this.counter = this.counter - 1;
                    } else {
                        this.stop();
                        this.playSound(soundMode);
                    }
                }
            },

            start:  function (mode, limit, interval) {
                console.log("interval");
                console.log(interval);
                mode == 'stopwatch' ? this.counter = 0 : this.counter = limit;
                this.isRunning = true;
                this.run = setInterval(() => {
                    this.count(mode, limit, this.soundMode);
                }, interval);

            },
            stop: function() {
                this.isRunning = false;
                clearInterval(this.run);
            },
            submitted: function() {
                this.$emit('timeSubmitted', this.counter);
                this.counter = 0;
                this.status = 0;
            }
        },
        created() {

        }
    }
</script>

<style>
    .btn-square-sm {
             height: 200px;
             font-size: xx-large;
             border-radius: 10px;
         }
    .btn-rectangle-sm-a {
             height: 134px;
             font-size: x-large;
             border-radius: 10px;
         }
    .btn-rectangle-sm-b {
        height: 58px;
        font-size: x-large;
        border-radius: 10px;
    }
    .btn-square-xs {
        height: 120px;
        font-size: xx-large;
        border-radius: 10px;
    }
    .btn-rectangle-xs-a {
        height: 76px;
        font-size: x-large;
        border-radius: 10px;
    }
    .btn-rectangle-xs-b {
        height: 38px;
        font-size: larger;
        border-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Stopwatch.vue